import { defineStore } from 'pinia'
import { store } from '../index'
import { UserLoginType, UserType } from '@/api/login/types'
import { ElMessageBox } from 'element-plus'
import { useI18n } from '@/hooks/web/useI18n'
// import { loginOutApi } from '@/api/login'
import { wxLoginApi, apLoginApi, registerApi, updateUserInfoApi,
   updatePasswordApi, updateUserAvatarApi, genCaptchaApi,captchaLoginApi} from '@/api/login'
import { getEnumApi, getDictOneApi } from '@/api/common'
import { useTagsViewStore } from './tagsView'
import router from '@/router'
import CryptoJS from 'crypto-js';


interface UserState {
  userInfo?: UserType
  tokenKey: string
  token: string
  roleRouters?: string[] | AppCustomRouteRecordRaw[]
  rememberMe: boolean
  loginInfo?: UserLoginType,

}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      token: '',
      roleRouters: undefined,
      // 记住我
      rememberMe: true,
      loginInfo: undefined
    }
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey
    },
    getToken(): string {
      return this.token
    },
    getUserInfo(): UserType | undefined {
      return this.userInfo
    },
    getRoleRouters(): string[] | AppCustomRouteRecordRaw[] | undefined {
      return this.roleRouters
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo
    }
  },
  actions: {
    async genCaptcha(data: {sceneType: string, phone: string}) {
      await genCaptchaApi(data)
    },
    async register(data: { loginId: string, password: string, phone:string, captcha:string }) {
      const result = await registerApi(data)
      const { accessToken,  userInfo } = result
      !!accessToken && this.setToken(accessToken) 
      !!userInfo && this.setUserInfo(userInfo) 
      return result
    },
    async wxLogin(code: string | any) {
      const result = await wxLoginApi({ code })
      const { accessToken,  userInfo } = result
      !!accessToken && this.setToken(accessToken) 
      !!userInfo && this.setUserInfo(userInfo) 
      return result
    },
    async apLogin(data: any) {
      const { loginId, password} = data
      const result = await apLoginApi({ loginId, password})
      const { accessToken,  userInfo } = result
      !!accessToken && this.setToken(accessToken) 
      !!userInfo && this.setUserInfo(userInfo) 
      return result
    },

    async captchaLogin(data: any) {
      const { phone, captcha} = data
      const result = await captchaLoginApi({ phone, captcha })
      const { accessToken,  userInfo } = result
      !!accessToken && this.setToken(accessToken) 
      !!userInfo && this.setUserInfo(userInfo) 
      return result
    },

    async updateUserInfo(data: any) {
      const { userName, email, phone } = data
      const result = await updateUserInfoApi( { userName, email, phone })
      !!result && this.setUserInfo(result) 
      return result
    },

    async updateUserAvatar(data: any) {
      const { base64: base64Avatar } = data
      const result = await updateUserAvatarApi( { base64Avatar })
      !!result && this.setUserInfo(result) 
      return result
    },

    async updatePassword( { password = undefined, newPassword = undefined } = {}) {
      if(!!password && !! newPassword && password !== newPassword) {
        const md5Password = CryptoJS.MD5(password).toString()
        const md5NewPassword = CryptoJS.MD5(newPassword).toString()
        const result = await updatePasswordApi( { password: md5Password, newPassword: md5NewPassword  })
        !!result && this.setUserInfo(result) 
        return result
      }
    },

    async getDict() {
      const result = await getEnumApi()
      return result
    },
    async getDictOne(code) {
      const result = await getDictOneApi(code)
      return result
    },
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey
    },
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo?: UserType) {
      this.userInfo = userInfo
    },
    setRoleRouters(roleRouters: string[] | AppCustomRouteRecordRaw[]) {
      this.roleRouters = roleRouters
    },
    async logoutConfirm(callback) {
      const { t } = useI18n()
      await ElMessageBox.confirm(t('common.loginOutMessage'), t('common.reminder'), {
        confirmButtonText: t('common.ok'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      })

      // const res = await loginOutApi().catch(() => {})
      // if (res) {
      //   this.reset()
      // }
      if(callback) {
        callback()
      }
      this.reset()
      // .then(() => {
      //   this.reset()
      // })
      // .catch((e) => { 
      //   console.log(e)
      // })
    },

    reset() {
      const tagsViewStore = useTagsViewStore()
      tagsViewStore.delAllViews()
      this.setToken('')
      this.setUserInfo(undefined)
      this.setRoleRouters([])
      router.replace('/login')
      window.location.reload()
    },
    logout() {
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo
    }
  },
  persist: {
    storage: localStorage
   }
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
